import { Layout } from "@/components/Layout";
import { Link } from "react-router-dom";
import { Building2, Target, Users, Award } from "lucide-react";

const About = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-background">
        <main className="container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 lg:py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-2">About Us</h1>
            <p className="text-sm sm:text-base text-muted-foreground mb-6 sm:mb-8">Empowering pharmaceutical businesses with intelligent solutions</p>

            <div className="space-y-4 sm:space-y-6 lg:space-y-8">
              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0 border border-primary/20">
                    <Building2 className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">KIREETI SOFT TECHNOLOGIES LIMITED.</h2>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">
                    KIREETI SOFT TECHNOLOGIES LIMITED. is a leading software solutions provider specializing in the pharmaceutical distribution and retail sector. With
                      years of experience in the industry, we understand the unique challenges faced by pharmaceutical businesses and deliver tailored solutions to
                      address them.
                    </p>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      Our flagship product, <span className="text-foreground font-semibold">Pharmasoft CS Director</span>, is designed to provide comprehensive business
                      intelligence, analytics, and management tools specifically crafted for the pharmaceutical industry.
                    </p>
                  </div>
                </div>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-accent/10 text-accent flex items-center justify-center flex-shrink-0 border border-accent/20">
                    <Target className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">Our Mission</h2>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      To empower pharmaceutical distributors, retailers, and healthcare businesses with cutting-edge technology solutions that enhance operational
                      efficiency, improve decision-making through data-driven insights, and drive sustainable growth in an increasingly competitive market.
                    </p>
                  </div>
                </div>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0 border border-primary/20">
                    <Award className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">Pharmasoft CS Director</h2>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed mb-3 sm:mb-4">
                      Pharmasoft CS Director is our comprehensive business intelligence platform that integrates seamlessly with your existing Pharmasoft systems. Key
                      features include:
                    </p>
                    <ul className="list-disc list-inside text-sm sm:text-base text-muted-foreground space-y-1.5 sm:space-y-2">
                      <li>Real-time sales dashboard with drill-down capabilities</li>
                      <li>Margin analysis at company and product levels</li>
                      <li>Outstanding analysis with party-wise breakdowns and risk scoring</li>
                      <li>Follow-up tracking with status updates and remarks</li>
                      <li>PS–CS integration for seamless data flow</li>
                      <li>Agent orders and receipts management</li>
                      <li>WhatsApp integration for automated alerts and follow-ups</li>
                      <li>Intelligent alerts and anomaly detection</li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <div className="flex items-start gap-3 sm:gap-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-accent/10 text-accent flex items-center justify-center flex-shrink-0 border border-accent/20">
                    <Users className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">Our Team</h2>
                    <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                      Our team comprises experienced professionals from both the pharmaceutical industry and technology sectors. This unique blend of expertise allows us
                      to understand your business challenges deeply and deliver solutions that truly make a difference. We are committed to providing excellent customer
                      support and continuous product improvements based on user feedback.
                    </p>
                  </div>
                </div>
              </section>

              <section className="bg-card rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-border">
                <h2 className="text-lg sm:text-xl font-semibold text-foreground mb-3 sm:mb-4">Get in Touch</h2>
                <p className="text-sm sm:text-base text-muted-foreground leading-relaxed">
                  We&apos;d love to hear from you. Whether you have questions about our products, need support, or want to explore partnership opportunities, please{" "}
                  <Link to="/contact" className="text-primary hover:underline">
                    contact us
                  </Link>
                  .
                </p>
              </section>
            </div>
          </div>
        </main>

         {/* Footer */}
      <footer className="border-t border-border mt-8 sm:mt-12 lg:mt-16 py-6 sm:py-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-6 text-xs sm:text-sm text-muted-foreground">
            <Link to="/about" className="hover:text-foreground transition-colors">
              About Us
            </Link>
            <Link to="/terms" className="hover:text-foreground transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="/refund" className="hover:text-foreground transition-colors">
              Refund & Cancellation
            </Link>
            <Link to="/contact" className="hover:text-foreground transition-colors">
              Contact Us
            </Link>
          </div>
          <p className="text-center text-sm text-muted-foreground mt-4">
            © {new Date().getFullYear()}{" "}
            <a
              href="https://kireetisoft.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-foreground transition-colors underline"
            >
              KIREETI SOFT TECHNOLOGIES LIMITED.
            </a>{" "}
            All rights reserved.
          </p>
        </div>
      </footer>
      </div>
    </Layout>
  );
};

export default About;

